<template>
  <b-overlay
    :show="loading"
    class="bg-white "
  >
    <div class="row">
      <div
        class="col-12 mt-3"
      >
        ¿Estás seguro de que quieres rechazar {{ batches.length }} lotes?
      </div>
      <div class="col-12 mt-3">
        <b-form
          id="form-message"
          data-vv-scope="form-message"
        >
          <b-row>
            <b-col cols="12">
              <b-form-group
                label="Motivo por el que se rechaza el lote"
                label-for="#"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="HelpCircleIcon"/>
                  </b-input-group-prepend>
                  <b-form-input
                    placeholder="Rechazado por no...."
                    v-model="cause"
                    v-validate="'required|min:6'"
                    data-cy="cause"
                    data-vv-as="Motivo"
                    id="cause"
                    name="cause"
                    :state="errors.has('form-message.cause') ? false : null"
                  />

                  <b-form-invalid-feedback>
                    {{ errors.first('form-message.cause') }}
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </div>
      <vs-divider></vs-divider>
      <b-col
        cols="12"
        class="text-right"
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          v-on:click="onApprove"
          data-cy="cancel-batch"
        >
          Si, Estoy seguro!
        </b-button>
      </b-col>
    </div>

  </b-overlay>
</template>
<script>

import MasivasMixin from '@/febos/global/_vue/mixins/MasivasMixin';
import { LLAMADA_MASIVA_ADUANA_RECHAZAR_LOTE_BASE } from '@/febos/servicios/api/aduanas/constantes';
import { ALERT_POSITION } from '@/febos/global/utils/configurations';

export default {
  mixins: [MasivasMixin],
  data() {
    return {
      loading: false,
      cause: ''
    };
  },
  props: {
    batches: {
      type: Array,
      required: true
    }
  },
  methods: {
    async onApprove() {
      const isValid = await this.$validator.validateAll('form-message');
      if (!isValid) {
        return;
      }
      const payload = {
        ...LLAMADA_MASIVA_ADUANA_RECHAZAR_LOTE_BASE,
        ...{
          comunes: {
            ...LLAMADA_MASIVA_ADUANA_RECHAZAR_LOTE_BASE.comunes,
            accion: 'rechazar',
            body: {
              mensaje: this.cause
            }
          },
          payload: this.batches.map(
            (batch) => ({
              lote_id: batch.loteId
            })
          )
        }
      };
      this.loading = true;
      try {
        await this.sendMasiveProcess(payload);
        this.$vs.notify({
          title: 'Genial!',
          text: `Se ha solicitado el rechazo de ${this.batches.length} lotes,
          te enviaremos un correo con los detalles cuando esta termine.`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          position: ALERT_POSITION
        });
        this.$emit('reject');
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.loading = false;
  }
};
</script>
